import OutageNotifications from './OutageNotifications';

export default OutageNotifications;
